import React from "react"
export function Pintrest() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="50px"
      height="50px"
      viewBox="0 0 50 50"
    >
      <path
        fill="#333333"
        d="M25.424,16.25c-4.936,0-7.424,3.521-7.424,6.458c0,1.778,0.676,3.361,2.127,3.95
c0.238,0.097,0.451,0.003,0.521-0.259c0.047-0.182,0.161-0.64,0.212-0.829c0.069-0.26,0.043-0.352-0.149-0.577
c-0.418-0.491-0.686-1.127-0.686-2.027c0-2.613,1.964-4.952,5.113-4.952c2.79,0,4.322,1.696,4.322,3.962
c0,2.981-1.325,5.498-3.292,5.498c-1.087,0-1.9-0.895-1.641-1.991c0.312-1.31,0.917-2.725,0.917-3.669
c0-0.847-0.456-1.552-1.4-1.552c-1.111,0-2.004,1.143-2.004,2.675c0,0.977,0.332,1.637,0.332,1.637s-1.137,4.794-1.335,5.634
c-0.397,1.672-0.061,3.723-0.032,3.929c0.017,0.123,0.175,0.152,0.247,0.06c0.103-0.133,1.425-1.76,1.875-3.384
c0.127-0.459,0.73-2.842,0.73-2.842c0.361,0.686,1.415,1.289,2.537,1.289c3.34,0,5.605-3.03,5.605-7.086
C32,19.106,29.39,16.25,25.424,16.25z"
      />
    </svg>
  )
}
export function LinkedIn() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="50px"
      height="50px"
      viewBox="0 0 50 50"
    >
      <path
        fill="#333333"
        d="M20.907,19.217c0,1.088-0.875,1.969-1.954,1.969c-1.078,0-1.953-0.881-1.953-1.969
      c0-1.086,0.875-1.967,1.953-1.967C20.032,17.25,20.907,18.131,20.907,19.217z M20.621,22.582h-3.303V33.25h3.303V22.582z
       M25.901,22.582h-3.168V33.25h3.168c0,0,0-3.957,0-5.6c0-1.5,0.69-2.393,2.013-2.393c1.215,0,1.798,0.857,1.798,2.393s0,5.6,0,5.6
      H33c0,0,0-3.896,0-6.754s-1.62-4.238-3.883-4.238s-3.216,1.762-3.216,1.762V22.582L25.901,22.582z"
      />
    </svg>
  )
}
export function Twitter() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="50px"
      height="50px"
      viewBox="0 0 50 50"
    >
      <path
        fill="#333333"
        d="M34,19.526c-0.662,0.301-1.374,0.505-2.121,0.596c0.762-0.468,1.348-1.21,1.623-2.095
      c-0.713,0.434-1.503,0.749-2.345,0.919c-0.674-0.736-1.633-1.196-2.695-1.196c-2.383,0-4.136,2.281-3.597,4.649
      c-3.069-0.157-5.791-1.665-7.612-3.957c-0.968,1.702-0.502,3.929,1.143,5.056c-0.604-0.02-1.175-0.19-1.672-0.474
      c-0.04,1.754,1.186,3.395,2.961,3.761c-0.52,0.145-1.089,0.179-1.667,0.065c0.47,1.504,1.833,2.6,3.449,2.63
      c-1.553,1.247-3.508,1.805-5.467,1.568c1.634,1.074,3.575,1.701,5.66,1.701c6.856,0,10.729-5.938,10.497-11.264
      C32.878,20.953,33.505,20.286,34,19.526z"
      />
    </svg>
  )
}
export function Facebook() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="50px"
      height="50px"
      viewBox="0 0 50 50"
      enableBackground="new 0 0 50 50"
    >
      <path
        fill="#333333"
        d="M22.814,22.135H21v3.077h1.814v9.038h3.491v-9.077h2.436L29,22.135h-2.694
      c0,0,0-1.135,0-1.73c0-0.717,0.14-1,0.806-1c0.537,0,1.889,0,1.889,0V16.25c0,0-1.99,0-2.417,0c-2.597,0-3.769,1.188-3.769,3.461
      C22.814,21.693,22.814,22.135,22.814,22.135z"
      />
    </svg>
  )
}
